import React, { useState } from "react";
import { failed, success } from "../../common/Toastify";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import { QuestionsFormikObj } from "./Constant";
import { Tooltip } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { createQuestion } from "../../api/Questionnaire";
import { QuestionForm } from "./QuestionForm";
import * as Yup from "yup";
import { useSelector } from "react-redux";

const CreateQuestion = () => {
  const navigate = useNavigate();
  const [btnLoading, setBtnLoading] = useState(false);
  const [tagValue, setTagValue] = useState();
  const userOrg = useSelector((s) => s?.auth?.user?.["custom:orgId"]);

  const channelDataMap = { id: Date.now(), text: "Phone" };

  const formik = useFormik({
    ...QuestionsFormikObj,
    initialValues: {
      ...QuestionsFormikObj.initialValues,
      orgId: userOrg || "",
      category: "",
    },
    validationSchema: Yup.object({
      orgId: Yup.string().required("Please select an Organization."),
      category: Yup.string()
        .required("Please fill the Category field")
        .matches(/^$|^\S+.*/, "Only blankspaces is not valid."),
      question: Yup.string()
        .required("Please fill the Question field")
        .matches(/^$|^\S+.*/, "Only blankspaces is not valid.")
        .max(400, "Must be 400 characters or less"),
      answerType: Yup.string()
        .required("Please fill the Answer Type field")
        .matches(/^$|^\S+.*/, "Only blankspaces is not valid."),
      note: Yup.string()
        .when("answerType", (answerType, schema) => {
          if (answerType === "freeText" || answerType === "singleFreeText")
            return schema
              .matches(/^$|^\S+.*/, "Only blankspaces is not valid.");
          return schema;
        })
        .matches(/^$|^\S+.*/, "Only blankspaces is not valid.")
        .max(250, "Must be 250 characters or less"),
      required: Yup.boolean(),
      options: Yup.array().when(["answerType", "tag"], (answerType, tag, schema) => {
        if (answerType !== "freeText" && answerType !== "singleFreeText" && tag !== "CHANNEL")
          return schema.of(
            Yup.object().shape({
              text: Yup.string().required("Please fill the answer field"),
            })
          );
        if (tag === "CHANNEL")
          return schema.of(
            Yup.object().shape({
              text: Yup.string().required("Please Select Chat/Video"),
            })
          );
        return schema;
      }),
    }),
    onSubmit: (values) => {
      setBtnLoading(true);
      values.tag = tagValue;

      if (
        tagValue === "CHANNEL" ||
        tagValue === "TELEPHONE" ||
        tagValue === "REASON" ||
        tagValue === "CALLER" ||
        tagValue === "LOCATION" ||
        tagValue === "RELATIONSHIP" ||
        tagValue === "SELFCALLING" ||
        tagValue === "CONSENT" ||
        tagValue === "INCLINATION" ||
        tagValue === "COMPLIANCE"
      ) {
        values.required = true;
      }

      if (values.tag === "CHANNEL") {
        const hasPhone = (values.options || []).some((o) => o.text === "Phone");
        if (!hasPhone) {
          values.options = [...(values.options || []), channelDataMap];
        }
      }

      const payload = {
        ...values,
        orgId: values.orgId || userOrg,
        category: values?.category?.split("%")?.[1] || "",
      };

      createQuestion(payload)
        .then((res) => {
          navigate("/app/manage-questions");
          success(res.message);
        })
        .catch((res) => {
          const errorMessage =
            res?.response?.data?.message ||
            res?.response?.data?.error ||
            res.message;
          failed(errorMessage);
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        })
        .finally(() => setBtnLoading(false));
    },
  });

  const handleQuestionTagValue = (value) => {
    if (typeof value === "string") setTagValue(value);
    if (typeof value === "object") {
      navigate("/app/create-questions");
      return;
    }
  };

  return (
    <section className="common-listing">
      <div className="heading-wrap mb-3">
        <Tooltip title="Go back">
          <div style={{ marginRight: "1rem", cursor: "pointer" }} onClick={() => navigate(-1)}>
            <ArrowBack />
          </div>
        </Tooltip>
      </div>
      <div className="custom-card p-4">
        <QuestionForm
          btnLoading={btnLoading}
          formik={formik}
          handleShow={() => navigate("/app/manage-questions")}
          isCreate={true}
          handleQuestionTagValue={handleQuestionTagValue}
          enableOrgChange={true}
        />
      </div>
    </section>
  );
};

export default CreateQuestion;